import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import AppWithTheme from "./AppWithTheme";
import reportWebVitals from "./reportWebVitals";
import { createStore } from "store";
import { LoadData } from "components";

Array.from(
  document.querySelectorAll(`.${process.env.REACT_APP_CONTAINER_CSS_CLASSNAME}`)
)
  .filter((element) => {
    const { productFormDataUrl, publicDirectoryUrl } = element.dataset;
    if (!productFormDataUrl) {
      console.warn(
        `Root element missing data attribute: "data-product-form-data-url"`
      );
    }
    if (!publicDirectoryUrl) {
      console.warn(
        `Root element missing data attribute: "data-public-directory-url"`
      );
    }
    return Boolean(productFormDataUrl && publicDirectoryUrl);
  })
  .forEach((element) => {
    const root = ReactDOMClient.createRoot(element);
    const {
      productFormDataUrl,
      publicDirectoryUrl,
      locale: initialLocale,
    } = element.dataset;
    const locale = initialLocale.replace("_", "-");
    root.render(
      <React.StrictMode>
        <Provider store={createStore({ locale })}>
          <AppWithTheme>
            <LoadData
              productFormDataUrl={productFormDataUrl}
              publicDirectoryUrl={publicDirectoryUrl.replace(/\/$/, "")}
              locale={locale}
            >
              <App publicDirectoryUrl={publicDirectoryUrl.replace(/\/$/, "")} />
            </LoadData>
          </AppWithTheme>
        </Provider>
      </React.StrictMode>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
